import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const MovixHelper = ({ strokeWidth = 1.5 }): JSX.Element => {
    return (
        <g id={'contour'}>
            <path
                strokeWidth={strokeWidth}
                d='M7.90966 3.88818C10.205 6.11975 13.8665 6.09396 16.1302 3.83028L16.5727 3.38779C16.9508 3.00966
                17.4672 2.90806 17.8691 3.083C18.1716 3.21468 18.3735 3.50185 18.613 3.72874L20.3493 5.37359C20.5888
                5.60049 20.8372 5.83781 20.9371 6.15227C21.029 6.44144 21.0202 6.7462 20.9108 7.03239C20.8119 7.29125
                20.6108 7.49331 20.4149 7.68925L20.256 7.84816C17.946 10.1581 17.9724 13.912 20.3147 16.1892L20.381
                16.2537C20.5994 16.4661 20.8227 16.6881 20.92 16.9768C21.075 17.4367 21.0047 17.9576 20.7092
                18.2531L18.2531 20.7092C17.9576 21.0047 17.4367 21.075 16.9767 20.92C16.6881 20.8227 16.4661 20.5995
                16.2537 20.3811L16.1873 20.3127C13.9108 17.9712 10.1593 17.9448 7.85012 20.254L7.68923 20.4149C7.4933
                20.6108 7.29126 20.8119 7.03246 20.9108C6.74622 21.0202 6.4414 21.029 6.15219 20.9371C5.83781 20.8372
                5.60049 20.5888 5.3736 20.3493L3.72873 18.613C3.50184 18.3735 3.21469 18.1716 3.083 17.8691C2.90806
                17.4673 3.00966 16.9508 3.38779 16.5727L3.82838 16.1321C6.09281 13.8677 6.11861 10.2038 3.88629
                7.90771L3.38779 7.39497C2.87074 6.87792 2.87074 6.2316 3.38779 5.71454L5.71454 3.38779C6.2316 2.87074
                6.87792 2.87074 7.39497 3.38779L7.90966 3.88818Z'
            />
        </g>
    );
};

export default createSvg(
    MovixHelper,
    'movix',
);
